<script>
    export let items = 4;
</script>

{#each Array(items) as item}
    <div class="col-md-6 col-lg-4 col-xl-3">
        <div class="product skeleton">
            <div class="product-logo"></div>
            <div class="product-name"></div>
            <div class="product-body">
                <div class="product-image"></div>
                <div class="product-props">
                    <div class="prop-item"></div>
                    <div class="prop-item"></div>
                    <div class="prop-item"></div>
                </div>
            </div>
            <div class="product-footer"></div>
        </div>
    </div>
{/each}

<style>
    .product.skeleton {
        display: block;
        height: 23rem;
        user-select: none;
        pointer-events: none;
        margin-bottom: 2rem;
        border-radius: 1.5rem;
        overflow: hidden;
        border: 1px solid var(--color-slate-200);
    }
    .product.skeleton .product-logo {
        height: 3rem;
        width: 10rem;
        margin: 1rem auto 0 auto;
        border-radius: 2.5rem;
        animation: skeletonLoading 1s linear infinite alternate;
    }
    .product.skeleton .product-name {
        height: 2rem;
        width: 80%;
        margin: 1rem auto;
        padding: 0 1rem;
        border-radius: 2.5rem;
        animation: skeletonLoading 1s linear infinite alternate;
    }
    .product.skeleton .product-body {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        margin: 1.3rem 0;
    }
    .product.skeleton .product-body .product-image {
        width: 9rem;
        height: 9rem;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        animation: skeletonLoading 1s linear infinite alternate;
    }
    .product.skeleton .product-body .product-props {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 40%;
    }
    .product.skeleton .product-body .product-props .prop-item {
        display: flex;
        flex-direction: row;
        overflow: hidden;
        border-color: transparent;
        width: 70%;
        height: 2.7rem;
        border-radius: .25rem;
        animation: skeletonLoading 1s linear infinite alternate;
    }
    .product.skeleton .product-footer {
        height: 6rem;
        padding: .8rem 0;
        animation: skeletonLoading 1s linear infinite alternate;
    }
</style>